// extracted by mini-css-extract-plugin
export default {"purchaseBtn":"WebxpayPayment_purchaseBtn__mda3l"};